module.exports = __webpack_public_path__ + "img/japan-transport-accidents-female.4c244195.png";